import { ALL_FACILITIES_QUERY, ALL_USER_FAVORITES_QUERY } from 'client/queries'
import { FACILITY_PAGE_LIMIT } from 'client/decorators/withInitialData'

const handleDeleteFacility = ({ id, mutate, ownProps }) =>
  mutate({
    variables: { id },
    optimisticResponse: {
      __typename: 'Mutation',
      deleteFacility: {
        __typename: 'Facility',
        id,
      },
    },
    refetchQueries: [
      {
        query: ALL_FACILITIES_QUERY,
        name: 'allFacilities',
        variables: {
          ...ownProps.variables,
          filter: null,
          limit: FACILITY_PAGE_LIMIT,
        },
      },
      {
        query: ALL_FACILITIES_QUERY,
        name: 'allFacilities',
        variables: {
          ...ownProps.variables,
          filter: { isArchived: true },
          limit: FACILITY_PAGE_LIMIT,
        },
      },
      {
        query: ALL_USER_FAVORITES_QUERY,
        name: 'allFacilities',
        variables: { limit: FACILITY_PAGE_LIMIT },
      },
    ],
  })

export default handleDeleteFacility
